import Vue from 'vue';
import App from './App.vue';
import Default from '@/layouts/Default.vue';
import Dashboard from '@/layouts/Dashboard.vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import "vue-swatches/dist/vue-swatches.min.css"
import '@/styles/main.less';
import { Auth } from '@axioms/web-js';
import router from '@/router';
import store from '@/store';
import VueClipboard from 'vue-clipboard2';
import axios from 'axios';
import AColorField from "@/components/Form/AColorField";
import AUrlField from "@/components/Form/AUrlField";
import AMultipleUrls from "@/components/FormSet/AMultipleUrls";
import AMultipleUris from "@/components/FormSet/AMultipleUris";
import ATextField from "@/components/Form/ATextField";
import ARolePermissionField from "@/components/Form/ARolePermissionField";
import ATextClipboardField from "@/components/Form/ATextClipboardField";
import ATextMiscField from "@/components/Form/ATextMiscField";
import ASlugField from "@/components/Form/ASlugField";
import ATextAreaField from "@/components/Form/ATextAreaField";
import ASelectField from "@/components/Form/ASelectField";
import ASwitchField from '@/components/Form/ASwitchField';
import ANumberField from '@/components/Form/ANumberField';
import APhoneField from '@/components/Form/APhoneField';
import ATimeUnitField from '@/components/Form/ATimeUnitField';
import ASubmitButton from '@/components/Form/ASubmitButton';
import ABreadCrumb from '@/components/Layout/ABreadCrumb';
import AAutoCompleteSelect from '@/components/Form/AAutoCompleteSelect';

Vue.use(VueClipboard);
Vue.use(Antd);

// Layout
Vue.component("default-layout", Default);
Vue.component("dashboard-layout", Dashboard);

// Custom form components global registration
Vue.component("a-color-field", AColorField);
Vue.component("a-url-field", AUrlField);
Vue.component("a-multiple-urls", AMultipleUrls);
Vue.component("a-multiple-uris", AMultipleUris);
Vue.component("a-text-field", ATextField);
Vue.component("a-text-clipboard-field", ATextClipboardField);
Vue.component("a-text-misc-field", ATextMiscField);
Vue.component("a-slug-field", ASlugField);
Vue.component("a-text-area-field", ATextAreaField);
Vue.component("a-select-field", ASelectField);
Vue.component("a-switch-field", ASwitchField);
Vue.component("a-number-field", ANumberField);
Vue.component("a-time-unit-field", ATimeUnitField);
Vue.component("a-phone-field", APhoneField);
Vue.component("a-submit-button", ASubmitButton);
Vue.component("a-bread-crumb", ABreadCrumb);
Vue.component("a-auto-complete-select", AAutoCompleteSelect);
Vue.component("a-role-permission-field", ARolePermissionField);


// Production
Vue.config.productionTip = false;
Vue.component("default-layout", Default);

// Auth
const auth = new Auth({
    axioms_domain: process.env.VUE_APP_Axioms_Domain,
    response_type: process.env.VUE_APP_Response_Type,
    redirect_uri: process.env.VUE_APP_Redirect_Uri,
    post_logout_uri: process.env.VUE_APP_Post_Logout_Uri,
    client_id: process.env.VUE_APP_Client_Id,
    scope: process.env.VUE_APP_Scope,
    post_login_navigate: '/'
});

Vue.prototype.$auth = auth;

Vue.prototype.$role = function(required_roles) {
    return auth.session.hasRole(required_roles);
};

Vue.prototype.$scope = function(required_scopes) {
    return auth.session.hasScope(required_scopes);
};

Vue.prototype.$permission = function(required_permissions) {
    return auth.session.hasPermission(required_permissions);
};

// Axios global config
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Authorization'] = `Bearer ${auth.session.access_token}`


new Vue({
    router,
    store,
    el: '#app',
    render: h => h(App),
});